import React from 'react';
import moment from 'moment';

export default class OrderHistory extends React.Component {
	constructor(props) {
		super(props);
		moment.locale(window.jenkon.culture);
	}

	createHistoryList(order) {
		return (
			<ul key={order.orderNumber} className="order-item clearfix">
				<li className="order-id">
					<a href="javascript:void(0);" onClick={this.props.getOrderDetails.bind(this, order.orderNumber)}>{order.orderNumber}</a>
				</li>
				<li className="order-date">{moment(order.orderDate).format('LLL')}</li>
				<li className="order-price">{order.orderTotal.displayValue}</li>
				<li className="order-status">{this.props.resources['PWS.MyAccount.OrderStatus' + order.orderStatus]}</li>
			</ul>
		)
	}

	render(){
		return(
			<div id="orders-section" className="site-container icon_button_content animate-in" aria-live="assertive">
				<div className="blurb text-center">
					<div className="title">{this.props.resources["PWS.MyAccount.OrderHistoryTitle"]}</div>
					<div className="description">{this.props.resources["PWS.MyAccount.OrderHistoryPageDescription"]}</div>
				</div>
				<div className="section-wrapper clearfix">
					<a href="javascript:void(0);" className="section-back-link" onClick={this.props.setView.bind(this)}>&laquo; &nbsp;{this.props.resources["PWS.MyAccount.BackToAccountButton"]}</a>
					<div className="dotted-HR"></div>
					<div>
						{this.props.OrderList.map(this.createHistoryList.bind(this))}
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/OrderHistory/OrderHistory.js